export default "__VITE_ASSET__C0xrTD43__"